import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// 重置浏览器默认样式
import "../public/cssreset.css";

// 引入echarts
import echarts from "echarts";
import "echarts-liquidfill"; //echarts 扩展水球图

import "echarts-wordcloud/dist/echarts-wordcloud";
import "echarts-wordcloud/dist/echarts-wordcloud.min";

Vue.prototype.$echarts = echarts;

// 引入echarts的高德地图插件，会自动注册
import "echarts-extension-amap";

// 引入highcharts并注册3d
import highcharts from "highcharts";
Vue.prototype.$highcharts = highcharts;
import highcharts3d from "highcharts/highcharts-3d";
highcharts3d(highcharts);

// 打开环境提示
Vue.config.productionTip = true;

import toast from './plug/Toast/index'
Vue.use(toast)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
